// extracted by mini-css-extract-plugin
module.exports = {"containerFilters":"PanelFilterContentWithBlocks_containerFilters__3jQBI","buttons":"PanelFilterContentWithBlocks_buttons__1njev","main":"PanelFilterContentWithBlocks_main__3mlwK"};